import { AnimalModelsTableConfig } from "./edit-animal-models.objects";
import { AnimalModelsTable } from "./edit-animal-models.table";

export class EditAnimalModelsPage {
    animalModelsTableConfig: AnimalModelsTableConfig;
    animalModelsTable: AnimalModelsTable;
    constructor() {
        $(() => {
            this.animalModelsTableConfig = {
                getAnimalModelsRoute: "/secure/animal-models-hub/edit-animal-models/edit-animal-models?handler=AnimalModels",
                tableContainerId: "animal-models-content",
                loadingContainerId: "loading-content-container",
                loadedContentId: "loaded-animal-models-content",
                isEditable: true,
                tableVarName: "animalModelsTable",
                isAdmin: false,
                editModalId: "edit-am-modal",
                postRoute: "/secure/animal-models-hub/edit-animal-models/edit-animal-models?handler=SaveAnimalModels",
                addModalId: "add-new-modal",
                additionalInfoModalId: "filterDefsModal"
            }

            this.animalModelsTable = new AnimalModelsTable(this.animalModelsTableConfig);
        });
    }

    closeAllModals() {
        $(".modal").modal('hide');
    }
}